var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-row",
        { staticStyle: { height: "30px", "border-bottom": "1px solid #ddd" } },
        [_c("el-col", { attrs: { span: 24 } }, [_vm._v(" 代采退换货单详情 ")])],
        1
      ),
      _vm._v(" "),
      _c(
        "el-row",
        {
          staticStyle: { height: "80px" },
          attrs: { type: "flex", align: "middle", justify: "center" }
        },
        [
          _c(
            "el-col",
            { attrs: { span: 24 } },
            [
              _c(
                "el-steps",
                {
                  attrs: {
                    space: "100%",
                    active: _vm.steps_label.index,
                    "finish-status": "success",
                    "process-status": _vm.steps_label.processStatus,
                    "align-center": ""
                  }
                },
                _vm._l(_vm.steps_label.steps, function(step, index) {
                  return _c("el-step", {
                    key: index,
                    attrs: { title: step.title, description: step.description }
                  })
                }),
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-row",
        [
          _c(
            "el-col",
            { attrs: { span: 24 } },
            [
              _c("el-alert", {
                attrs: {
                  title: "当前退换货单状态：" + _vm.info.status_str,
                  type: "success",
                  closable: false
                }
              })
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-row",
        { staticStyle: { border: "1px solid #ddd" } },
        [
          _c(
            "el-col",
            { attrs: { span: 24 } },
            [
              _c(
                "el-row",
                {
                  staticStyle: {
                    background: "#f3f3f3",
                    height: "30px",
                    "line-height": "30px",
                    padding: "0 25px"
                  }
                },
                [_c("el-col", { attrs: { span: 24 } }, [_vm._v(" 基本信息 ")])],
                1
              ),
              _vm._v(" "),
              _c(
                "el-row",
                [
                  _c(
                    "el-col",
                    { attrs: { span: 24 } },
                    [
                      _c(
                        "el-table",
                        {
                          staticStyle: { width: "100%" },
                          attrs: { data: [_vm.info], border: "" }
                        },
                        [
                          _c("el-table-column", {
                            attrs: {
                              prop: "receipt_sn",
                              label: "代采退换货单编号",
                              align: "center"
                            }
                          }),
                          _vm._v(" "),
                          _c("el-table-column", {
                            attrs: {
                              prop: "quantity",
                              label: "退换货数量",
                              align: "center"
                            }
                          }),
                          _vm._v(" "),
                          _c("el-table-column", {
                            attrs: {
                              prop: "market_name",
                              label: "市场/子市场",
                              align: "center"
                            }
                          }),
                          _vm._v(" "),
                          _c("el-table-column", {
                            attrs: {
                              prop: "supply_name",
                              label: "商家",
                              align: "center"
                            }
                          }),
                          _vm._v(" "),
                          _c("el-table-column", {
                            attrs: {
                              prop: "dpc_name",
                              label: "次品专员",
                              align: "center"
                            }
                          }),
                          _vm._v(" "),
                          _c("el-table-column", {
                            attrs: {
                              prop: "work_id",
                              label: "售后工单ID",
                              align: "center"
                            }
                          }),
                          _vm._v(" "),
                          _c("el-table-column", {
                            attrs: {
                              prop: "purchaser_gname",
                              label: "代采组",
                              align: "center"
                            }
                          }),
                          _vm._v(" "),
                          _c("el-table-column", {
                            attrs: {
                              prop: "woid",
                              label: "代采订单号",
                              align: "center"
                            }
                          }),
                          _vm._v(" "),
                          _c("el-table-column", {
                            attrs: {
                              prop: "status_str",
                              label: "状态",
                              align: "center"
                            }
                          }),
                          _vm._v(" "),
                          _c("el-table-column", {
                            attrs: {
                              prop: "create_time",
                              label: "生成时间",
                              align: "center"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-row",
        [
          _c(
            "el-col",
            { attrs: { span: 24 } },
            [
              _c(
                "el-col",
                [
                  _c("div", { staticClass: "card-title" }, [
                    _vm._v("商品信息")
                  ]),
                  _vm._v(" "),
                  _c(
                    "el-table",
                    {
                      staticStyle: { width: "100%" },
                      attrs: { data: _vm.info.goods, border: "" }
                    },
                    [
                      _c("el-table-column", {
                        attrs: {
                          prop: "goods_img",
                          label: "商品图片",
                          align: "center"
                        },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function(scope) {
                              return [
                                _c(
                                  "div",
                                  {
                                    directives: [
                                      { name: "viewer", rawName: "v-viewer" }
                                    ],
                                    staticStyle: {
                                      width: "40px",
                                      height: "40px",
                                      overflow: "hidden",
                                      cursor: "pointer",
                                      margin: "auto"
                                    }
                                  },
                                  [
                                    _c("img", {
                                      staticStyle: {
                                        width: "100%",
                                        height: "100%"
                                      },
                                      attrs: { src: scope.row.goods_img }
                                    })
                                  ]
                                )
                              ]
                            }
                          }
                        ])
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: {
                          prop: "type_str",
                          label: "退换原因",
                          align: "center"
                        }
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: {
                          prop: "quantity",
                          label: "数量",
                          align: "center"
                        }
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: {
                          prop: "barter_img",
                          label: "换回图片",
                          align: "center"
                        },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function(scope) {
                              return [
                                _c(
                                  "div",
                                  {
                                    directives: [
                                      { name: "viewer", rawName: "v-viewer" }
                                    ],
                                    staticStyle: {
                                      width: "40px",
                                      height: "40px",
                                      overflow: "hidden",
                                      cursor: "pointer",
                                      margin: "auto"
                                    }
                                  },
                                  [
                                    _c("img", {
                                      staticStyle: {
                                        width: "100%",
                                        height: "100%"
                                      },
                                      attrs: { src: scope.row.goods_img }
                                    })
                                  ]
                                )
                              ]
                            }
                          }
                        ])
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: {
                          prop: "goods_name",
                          label: "换回名称",
                          align: "center"
                        }
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: {
                          prop: "goods_no",
                          label: "换回货号",
                          align: "center"
                        }
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: {
                          prop: "co_val",
                          label: "换回颜色",
                          align: "center"
                        }
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: {
                          prop: "si_val",
                          label: "换回尺码",
                          align: "center"
                        }
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: {
                          prop: "price",
                          label: "换回代采价",
                          align: "center"
                        }
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: {
                          prop: "subtotal",
                          label: "小计",
                          align: "center"
                        }
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: {
                          prop: "process_type_str",
                          label: "状态",
                          align: "center"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-row",
        [
          _c(
            "el-col",
            { attrs: { span: 24 } },
            [
              _c("div", { staticClass: "card-title" }, [_vm._v("操作信息")]),
              _vm._v(" "),
              _c(
                "el-table",
                {
                  staticStyle: { width: "100%" },
                  attrs: { data: _vm.logs, border: "", height: "400" }
                },
                [
                  _c("el-table-column", {
                    attrs: {
                      prop: "operator_name",
                      label: "操作人",
                      align: "center"
                    }
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "type_str",
                      label: "操作方式",
                      align: "center"
                    }
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { prop: "result", label: "结果", align: "center" }
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "create_time",
                      label: "操作时间",
                      align: "center"
                    }
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { prop: "remark", label: "备注", align: "center" }
                  })
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-fc84d772", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-fc84d772","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/ReturnAndExchangeDetail.vue
// module id = null
// module chunks = 